import apiFetch from '../apiFetch'

export default function (values, token) {
  return apiFetch({endPoint: `Pedido/editarPedido`, method: 'POST', body: values, token: token})
}
